import React from 'react'
import { DSButton, DSSpacer, DSText } from '@zoe/ds-web'
import { onNextClickType } from 'components/types'
import { ScreenContainer } from '../core/layout/ScreenContainer'
import { StickyFooter, StickyFooterContent } from '../core/layout/StickyFooter'
import { ContextAwareText } from '../core/text/ContextAwareText'
import { Quizzes } from '../../redux/quiz/types'
import { FutureYouGraph } from './FutureYouGraph'

export type FutureYouScreenProps = {
  title: string
  description?: string
}

type Props = FutureYouScreenProps & {
  onNextClick: onNextClickType
  quiz: Quizzes
}

// A lean playback screen that always renders the generic animated
// "future you" graph (NOW → YOUR HEALTH). Structurally mirrors
// WeightCalculationScreen but takes only a title + description, so product
// can drop it into any quiz as a reusable building block.
export const FutureYouScreen: React.FC<Props> = ({ title, description, onNextClick, quiz }) => {
  return (
    <ScreenContainer>
      <DSText variant="fluid-heading-700" weight="semiBold" align="left">
        {title}
      </DSText>
      <DSSpacer size={24} direction="vertical" />

      <FutureYouGraph />

      {description && (
        <>
          <DSSpacer size={24} direction="vertical" />
          <DSText variant="fluid-paragraph-400" color="secondary">
            <ContextAwareText text={description} quiz={quiz} />
          </DSText>
        </>
      )}

      <StickyFooter>
        <StickyFooterContent>
          <DSButton
            variant="primary"
            colorScheme="default"
            size="large"
            width="full"
            onPress={onNextClick}
            testId="continue-button"
          >
            <DSText variant="fluid-paragraph-200" weight="semiBold">
              Continue
            </DSText>
          </DSButton>
        </StickyFooterContent>
      </StickyFooter>
    </ScreenContainer>
  )
}
